<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div
            class="relative flex flex-col min-w-0 break-words w-full rounded-lg bg-blueGray-100 border-0"
        >
          <div class="rounded-t bg-white mb-0 px-6 py-6">
            <div class="text-center flex justify-between">
              <h6 class="text-blueGray-700 text-xl font-bold">{{ $t('edit_locker') }}</h6>
            </div>
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                {{ $t('locker_info') }}
              </h6>
              <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    >
                      {{ $t('name') }}
                    </label>
                    <input
                        v-model="name"
                        type="text"
                        :placeholder="$t('name')"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    >
                      {{ $t('address') }}
                    </label>
                    <input
                        v-model="address"
                        type="text"
                        :placeholder="$t('address')"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    >
                      {{ $t('latitude') }}
                    </label>
                    <input
                        v-model="latitude"
                        type="text"
                        :placeholder="$t('latitude')"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    >
                      {{ $t('longitude') }}
                    </label>
                    <input
                        v-model="longitude"
                        type="text"
                        :placeholder="$t('longitude')"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    >
                      Password
                    </label>
                    <input
                        v-model="password"
                        type="text"
                        placeholder="Password"
                        class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                        class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    >
                      {{ $t('type') }}
                    </label>
                    <select v-model="is_public"
                            type="text"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                      <option value="0">{{ $t('private') }}</option>
                      <option value="1">{{ $t('public') }}</option>
                    </select>
                  </div>
                </div>
                <div
                    class="w-full flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b py-3">
                  <button
                      class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button" v-on:click="toggleModal">
                    {{ $t('close') }}
                  </button>
                  <button
                      class="bg-yellow-400 text-white ative:bg-yellow-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button" v-on:click="formSubmit">
                    {{ $t('save_changes') }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthService from "../../../services/auth.service";

export default {
  data() {
    return {
      name: '',
      address: '',
      longitude: '',
      latitude: '',
      password: '',
      is_public: '',
      AuthService
    };
  },

  mounted() {
    let locker = this.$parent.lockers[this.$props.index];
    this.name = locker.name;
    this.address = locker.address;
    this.latitude = locker.latitude;
    this.longitude = locker.longitude;
    this.password = locker.password;
    this.is_public = locker.is_public;
  },

  methods: {
    toggleModal: function () {
      this.$parent.toggleEditLocker();
    },

    formSubmit(e) {
      e.preventDefault();
      let locker = this.$parent.lockers[this.$props.index];
      if(this.name !== '' || this.address !== '' || this.latitude !== '' || this.longitude !== '' || this.is_public !== '') {
        // Modifica il locker se tutti i campi sono pieni e anche la password è stata modificata
        if (this.password !== '') {
          AuthService.editLocker(locker.id, this.name, this.address, this.latitude, this.longitude, this.password, this.is_public, locker.status).then(
              response => {
                if (response.data.status === "success") {
                  // Aggiorna i locker in caso di successo
                  AuthService.getLockers().then(
                      response => {
                        this.$parent.lockers = response.data.message;
                      }
                  );
                  this.$fire({
                    title: this.$t('success'),
                    text: this.$t('locker_edited_succ'),
                    type: "success",
                    confirmButtonColor: "#fbbf24",
                    timer: 3000
                  });
                } else {
                  this.$fire({
                    title: this.$t('error'),
                    html: this.$t('error_occurred') + ".<br>(" + response.data.message + ")",
                    type: "error",
                    confirmButtonColor: "#fbbf24",
                    timer: 3000
                  });
                }
              }
          );
        } else
            // Modifica il locker se tutti i campi sono pieni, tranne quello della password (non viene modificata)
          AuthService.editLocker(locker.id, this.name, this.address, this.latitude, this.longitude, false, this.is_public, locker.status).then(
              response => {
                if (response.data.status === "success") {
                  // aggiorna i locker in caso di successo
                  AuthService.getLockers().then(
                      response => {
                        this.$parent.lockers = response.data.message;
                      }
                  );
                  this.$fire({
                    title: this.$t('success'),
                    text: this.$t('locker_edited_succ'),
                    type: "success",
                    confirmButtonColor: "#fbbf24",
                    timer: 3000
                  });
                } else {
                  this.$fire({
                    title: this.$t('error'),
                    html: this.$t('error_occurred') + ".<br>(" + response.data.message + ")",
                    type: "error",
                    confirmButtonColor: "#fbbf24",
                    timer: 3000
                  });
                }
              }
          );
      } else {
        this.$fire({
          title: this.$t('error'),
          text: this.$t('all_fields_full_ex_pass'),
          type: "error",
          confirmButtonColor: "#fbbf24",
          timer: 3000
        });
      }
      this.toggleModal();
    }
  },

  props: {
    index: Number,
  }
}
</script>
